"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BasicFormImages_1 = require("./BasicFormImages");
var lodash_1 = require("lodash");
var PrefillCompatibleForm_1 = require("./PrefillCompatibleForm");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var getOptions = function (di) { return ({
    legalEntityLabel: di.has("legalEntityLabel") ? di.get("legalEntityLabel") : "Business Name",
    hideNameIfFilled: di.has("hideNameIfFilled") ? di.get("hideNameIfFilled") : false,
    isLegacy: di.has("isLegacy") ? di.get("isLegacy") : false,
}); };
var BasicForm = (function () {
    function BasicForm(createUi, acceptData, isPreviewMode, di, utils, invoke, settings, usingFeature) {
        var _this = this;
        var _a;
        this.validate = function () { return false; };
        this.devFill = function () { };
        this.previewAutoFill = function () { };
        var _b = getOptions(di), legalEntityLabel = _b.legalEntityLabel, hideNameIfFilled = _b.hideNameIfFilled, isLegacy = _b.isLegacy;
        if (!acceptData.name)
            acceptData.name = "";
        if (!acceptData.email)
            acceptData.email = "";
        if (!acceptData.legalEntity)
            acceptData.legalEntity = "";
        var dataCaptureItems = [
            {
                label: "Name",
                placeholder: "Firstname Lastname",
                icon: BasicFormImages_1.User,
                model: "name",
                type: "text",
                friendlyName: "Name",
            },
            {
                label: "Email",
                placeholder: "name@email.com",
                icon: BasicFormImages_1.Mail,
                model: "email",
                type: "email",
                friendlyName: "Email",
            },
            {
                label: "".concat(legalEntityLabel, " (optional)"),
                placeholder: "".concat(legalEntityLabel, " name"),
                icon: BasicFormImages_1.Company,
                model: "legalEntity",
                type: "text",
                friendlyName: legalEntityLabel,
            },
        ];
        if (hideNameIfFilled && ((_a = acceptData.name) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            (0, lodash_1.pullAllBy)(dataCaptureItems, [{ model: "name" }], "model");
        }
        if (isLegacy) {
            dataCaptureItems.forEach(function (item) { return (item.placeholder = item.label); });
        }
        var $timeout = di.get("$timeout");
        var consumerDataServiceBaseUrl = di.has("consumerDataServiceBaseUrl") ? di.get("consumerDataServiceBaseUrl") : "";
        var authAppBaseUrl = di.has("authAppBaseUrl") ? di.get("authAppBaseUrl") : "";
        var isUsingAcceptBlockPrintMode = usingFeature(FeatureFlag_1.default.AcceptBlockPrintMode);
        var isPrintMode = isUsingAcceptBlockPrintMode && di.has("isPrintMode") ? di.get("isPrintMode") : false;
        var prefillProps = {
            registerImperativeHandlers: function (handlers) { return ((_this.validate = handlers.validate),
                (_this.devFill = function () { return handlers.devFill(utils.randomString); }),
                (_this.previewAutoFill = function () { return handlers.previewAutoFill(); })); },
            fields: dataCaptureItems.map(function (item) { return ({
                name: item.model,
                friendlyName: item.friendlyName,
                placeholder: item.placeholder,
                label: item.label,
                isOptional: item.model === "legalEntity",
                type: item.model === "email" ? kaleidoscope_1.TextInputType.Email : kaleidoscope_1.TextInputType.Text,
            }); }),
        };
        this.name = "basicForm";
        this.ui = createUi(require("./BasicForm.html"), {
            prefillableForm: null,
            $init: function ($scope) {
                _this.ui.prefillableForm = invoke(PrefillCompatibleForm_1.mountPrefillableForm, undefined, {
                    props: prefillProps,
                    acceptData: acceptData,
                    consumerDataServiceBaseUrl: consumerDataServiceBaseUrl,
                    authAppBaseUrl: authAppBaseUrl,
                    isPreviewMode: isPreviewMode,
                    isPrintMode: isPrintMode,
                    $scope: $scope,
                    $timeout: $timeout,
                    esignEnabled: settings.esignEnabled,
                });
            },
        });
    }
    return BasicForm;
}());
exports.default = BasicForm;
